import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { Keyboard } from '@capacitor/keyboard';
import { IbanOption, WithdrawalSteps } from '@inyova/models';

import { WithdrawValidator } from '../../validators/withdrawal.validator';

@Component({
  selector: 'app-withdrawal-iban',
  templateUrl: './withdrawal-iban.component.html',
  styleUrls: ['./withdrawal-iban.component.scss'],
  standalone: false
})
export class WithdrawalIbanComponent implements OnInit {
  @Input() appLocation: 'ch' | 'de';
  @Input() ibanList: IbanOption[];
  @Input() isMobileApp: boolean;
  @Input() parent: FormGroup;
  @Output() ibanCheck: EventEmitter<string> = new EventEmitter<string>();
  @Output() prevStep: EventEmitter<void> = new EventEmitter<void>();
  @Output() nextStep: EventEmitter<WithdrawalSteps> = new EventEmitter<WithdrawalSteps>();
  @Output() trackActivity: EventEmitter<string> = new EventEmitter<string>();

  get typeControl(): AbstractControl | null {
    return this.parent.get('type');
  }

  get ibanControl(): AbstractControl | null {
    return this.parent.get('iban');
  }

  get newIbanControl(): AbstractControl | null {
    return this.parent.get('newIban');
  }

  ngOnInit() {
    this.ibanList = [
      ...this.ibanList,
      {
        title: 'ACCOUNT.withdrawalV2.bank.radios.new.label',
        desc: 'ACCOUNT.withdrawalV2.bank.radios.new.description',
        type: 'new',
        value: ''
      }
    ];
  }

  onFocus() {
    if (this.newIbanControl.hasError('invalidIban')) {
      this.newIbanControl.setErrors({ invalidIban: null });
      this.newIbanControl.updateValueAndValidity();
    }
  }

  onIbanChange(iban: IbanOption) {
    this.typeControl.setValue(iban.type);
    this.typeControl.updateValueAndValidity();
    this.ibanControl.setValue(iban.value);
    this.updateValidation(iban.type);
    this.trackActivity.emit(`[Button] New Withdrawal: Select ${iban.type === 'new' ? 'new' : 'existing'} IBAN `);
  }

  updateValidation(ibanType: 'account' | 'new') {
    if (ibanType === 'new') {
      this.newIbanControl.setValidators([Validators.required, WithdrawValidator.customIbanCheck()]);
    } else {
      this.newIbanControl.clearValidators();
    }
    this.newIbanControl.updateValueAndValidity();
  }

  onBack() {
    this.prevStep.emit();
  }

  onContinue() {
    if (this.parent.invalid) return;

    if (this.isMobileApp) {
      void Keyboard.hide();
    }

    if (this.typeControl.value === 'account') {
      this.nextStep.emit(WithdrawalSteps.REASONS);
      return;
    }

    this.ibanCheck.emit(this.newIbanControl.value);
  }
}
